export interface AuthenticatedUser {
  username: string;
  role: UserRole;
  token: string;
  otpRequired?: boolean;
  language: string;
  isChainDoctor: boolean;
  isGlobalTechnician: boolean;
  nurseSettings?: NurseSettings;
}

export interface NurseSettings {
  allowedLocalMeasurementTypes: boolean;
  allowedHomeMeasurementTypes: boolean;
  hasOperatorHospitals: boolean;
  allowedSsnInput: boolean;
  allowedComments: boolean;
  allowedInitiateWithDeviceSerial: boolean;
}

export const ALL_USER_ROLES = ["NURSE", "DATA_OFFICER", "DOCTOR", "HMO"] as const;
type UserRoleTuple = typeof ALL_USER_ROLES;
export type UserRole = UserRoleTuple[number]; // union type

export function isValidAuthenticatedUser(user: AuthenticatedUser) {
  return !!user && !!user.username && !!user.role && !!user.token;
}

export function allUserRolesExcept(...excludedRole: UserRole[]): UserRole[] {
  return ALL_USER_ROLES.filter(
    (role): role is UserRole => !excludedRole.includes(role)
  );
}
